const imageConfigValues = {
  IMAGE_MAX_PIXEL_WIDTH_OR_HEIGHT: 1800,
  IMAGE_MIN_FINAL_WIDTH: 849,
  IMAGE_CROPPER_WIDTH: 450,
};

export const convertFileToBase64 = async (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    const img = new Image();
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    let factor;
    const maxPixels = imageConfigValues.IMAGE_MAX_PIXEL_WIDTH_OR_HEIGHT;
    if (file) {
      switch (file?.type) {
        case 'application/pdf':
          reader.readAsDataURL(file);
          reader.onload = (e) => {
            if (e.target?.result) {
              return resolve(e.target.result as string);
            }
          };
          break;
        default:
          reader.readAsDataURL(file);
          reader.onloadend = () => {
            // img.type = 'image/jpg';
            if (reader.result) {
              img.src = reader.result as string;
            }
            img.onload = () => {
              if (img.width > maxPixels || img.height > maxPixels) {
                if (img.width > img.height) {
                  factor = img.width / maxPixels;
                } else {
                  factor = img.height / maxPixels;
                }
                canvas.width = img.width / factor;
                canvas.height = img.height / factor;
                ctx?.drawImage(img, 0, 0, canvas.width, canvas.height);
                img.src = canvas.toDataURL('image/jpeg', 1);
                img.onload = () => {
                  return resolve(img.src);
                };
              } else {
                return resolve(img.src);
              }
            };
          };
          break;
      }
    }
    reader.onerror = (error) => {
      return reject(`Error on converToBase64: ${error}`);
    };
  });
};

//
// export const convertFileToBase64 = (file: File, cb: (res: string) => void) => {
//   const reader = new FileReader();
//   const img = new Image();
//   const canvas = document.createElement('canvas');
//   const ctx = canvas.getContext('2d');
//   let factor;
//   const maxPixels = imageConfigValues.IMAGE_MAX_PIXEL_WIDTH_OR_HEIGHT;
//   if (file) {
//     switch (file?.type) {
//       case 'application/pdf':
//         reader.readAsDataURL(file);
//         reader.onload = (e) => {
//           if (e.target?.result) {
//             cb(e.target.result as string);
//           }
//         };
//         break;
//       default:
//         reader.readAsDataURL(file);
//         reader.onloadend = () => {
//           // img.type = 'image/jpg';
//           if (reader.result) {
//             img.src = reader.result as string;
//           }
//           img.onload = () => {
//             if (img.width > maxPixels || img.height > maxPixels) {
//               if (img.width > img.height) {
//                 factor = img.width / maxPixels;
//               } else {
//                 factor = img.height / maxPixels;
//               }
//               canvas.width = img.width / factor;
//               canvas.height = img.height / factor;
//               ctx?.drawImage(img, 0, 0, canvas.width, canvas.height);
//               img.src = canvas.toDataURL('image/jpeg', 1);
//               img.onload = () => {
//                 cb(img.src);
//               };
//             } else {
//               cb(img.src);
//             }
//           };
//         };
//         break;
//     }
//   }
//   reader.onerror = (error) => {
//     console.log('Error on convertToBase64: ', error);
//   };
// };
